const Search = {

    init() {

        this.el = $('[component="Search"]');

        if (!this.el.length) {
            // return;
        }

        this.input = $('input[name="search"]');

        this.bind();
    },

    bind() {
        $(document).on({
            keyup: function (e) {
                let input = $(e.target);

                let searchIN = $(input).data('searchtarget');
                let searchEmptyAlert = $(input).parents('[component="Search"]').find('.notFoundAlert');

                let value = $(input).val().toLowerCase().trim();
                let v = value.split(" ");//%

                $(searchIN).each(function (j, k) {
                    let s = true;
                    $.each(v, function (i, x) {
                        if (s) {
                            s = $(k).text().toLowerCase().indexOf(x) > -1;
                        }
                    });

                    $(this).toggle(s);
                });

                let visibleRow = $(searchIN + ':visible');

                if (visibleRow.length == 0) {

                    searchEmptyAlert.find('strong').text(value);
                    searchEmptyAlert.show(0);

                    $('.searchCount').hide(0);
                } else {
                    searchEmptyAlert.hide(0);

                    $('.searchCount').children().text(visibleRow.length);
                    $('.searchCount').show(0);
                }


                if (value.length == 0) {
                    $(input).removeClass('withValue');

                    $('table .hidden').removeAttr('style');
                    $('.paginator').show(0);
                    $('.searchCount').hide(0);
                } else {
                    $(input).addClass('withValue');
                    $('.paginator').hide(0);
                }
            },
            focusin: function (e) {
                $(this).text('');
            }/*,
		focusout: function (e) {
			if ( $(this).text().length == 0 ) {
				$(this).text(defaultSearchPlaceholder);
			}
		}*/
        }, Search.input);
    },

}
export default Search;